import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';

import { SuperAdminService } from 'src/app/services/super-admin.service';
import { MenuItem, MessageService, ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-farmer-application-verification',
  templateUrl: './farmer-application-verification.component.html',
  styleUrls: ['./farmer-application-verification.component.scss'],
})
export class FarmerApplicationVerificationComponent implements OnInit {
  
  constructor(
    private route: ActivatedRoute, 
    private cryptoJsService: CryptoJsService, 
    private router: Router,
    private activityRecordService: ActivityRecordService,
  
     private adminservice: SuperAdminService,
      private messageService: MessageService, 
    ) { }


  items: any[];
  autoId: any;
  appId: any;

  activeItem: any;
  userID: any;



 public geoMappings: any[] = [];
  public loading = false;

  //public userID: string = '';
  public userRole: string = '';
  //public jeLogin: boolean = false;
  //public xenLogin: boolean = false;
  public ddAssociateLogin: boolean = false;
  public dimicadaLogin: boolean = false;
  public filteredGeoMappings: any[] = [];
  public showGeoDialog = false;
  hoveredRow: number = -1;



  ngOnInit() {

 this.initializeUserFromToken();
  setTimeout(() => {
    // slight delay ensures userID loaded before filtering
    this.loadGeoMappings();
  }, 300);

    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;


    let parentRoute = this.router.url.split('/')[1];
    this.route.queryParams
      .subscribe(params => {
        // this.autoId = params.autoId;
        // this.appId = params.appId;
        this.items = [
          { label: 'Pending', routerLink: `/${parentRoute}/farmer-applications/pending`},
          { label: 'Current', routerLink: `/${parentRoute}/farmer-applications/current`},
          { label: 'Further Action Taken', routerLink: `/${parentRoute}/farmer-applications/approved` },          
        ];
      }
      );
      
  }


// ✅ Extract user info from token or localStorage
initializeUserFromToken() {
  const token = sessionStorage.getItem('token');
  if (token) {
    try {
      const tokenData = JSON.parse(this.cryptoJsService.DecryptToken(token));

      this.userID = tokenData?.userID?.trim() || '';
      this.userRole = tokenData?.role || '';

      console.log('🔐 Token Data:', tokenData);
      console.log('👤 Extracted userID:', this.userID, 'Role:', this.userRole);

      // Save in localStorage for later use (backup)
      localStorage.setItem('userID', this.userID);
      localStorage.setItem('userRole', this.userRole);

      this.ddAssociateLogin = this.userRole === 'DD Associate';
      this.dimicadaLogin = this.userRole === 'DMICADA';
    } catch (err) {
      console.error('❌ Error parsing token:', err);
    }
  } else {
    // 🔁 Fallback if session token missing
    this.userID = localStorage.getItem('userID') || '';
    this.userRole = localStorage.getItem('userRole') || '';
    console.warn('⚠️ Token not found, loaded from localStorage:', this.userID);
  }
}

// ------------------------------------------------------------------------
// ✅ Fetch and filter mappings *after* user info is ready
loadGeoMappings() {
  this.loading = true;
  console.log(`📡 Fetching GeoMappings for userID: ${this.userID} (${this.userRole})`);

  this.adminservice.GetAllGeoMappings().subscribe({
    next: (res: any) => {
      console.log('✅ Full API Response:', res);
      this.geoMappings = res?.$values || [];

      // ✅ Case-insensitive + trim-safe filter for DD Associate
      if (this.ddAssociateLogin && this.userID) {
        this.filteredGeoMappings = this.geoMappings.filter(
          (item: any) =>
            item.userID?.trim().toLowerCase() === this.userID?.trim().toLowerCase()
        );
      } else {
        this.filteredGeoMappings = [];
      }

      console.log('🎯 Filtered Mappings:', this.filteredGeoMappings);

      if (this.filteredGeoMappings.length === 0) {
        this.messageService.add({
          severity: 'info',
          summary: 'No Areas Assigned',
          detail: `No areas assigned for ${this.userID} (${this.userRole}).`
        });
      }

      this.loading = false;
    },
    error: (err) => {
      console.error('❌ Error loading geo mappings:', err);
      this.loading = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to load Geo Mappings'
      });
    }
  });
}

  // ------------------------------------------------------------------------
  // ✅ Dialog controls
  openGeoMappingPopup() {
    this.showGeoDialog = true;
  }

  onGeoDialogClose() {
    this.showGeoDialog = false;
  }
}